import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // Start at 14 minutes and 50 seconds
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 50);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const intervalId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <span className="font-mono font-bold tracking-wider" data-id="element-3">
      {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
    </span>;
}